<app-loader [Parent]="this"></app-loader>
@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      <div style="display: inline-flex;">
        <valetactionbuttons #ValetButtons [ModelId]="Model.Id" [AllowedActions]="Model.Actions"></valetactionbuttons>
        <form-edit-button>Edit</form-edit-button>
      </div>
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Valet Session Details
            <span><button class="button" (click)="ShowHistory()" style="float:right; height:100%; background:none; border:none; padding-top:0px; font-size: 0.8em;"><i class="fa-solid fa-clock-rotate-left" style="margin-right:10px;"></i> History</button></span>
          </p>
          <div class="panel-block">
            <span class="label">Ticket Number:</span>
            <span class="value"><input class="button" style="height:2em; text-align: center; pointer-events:none; font-weight: bold;" [value]="Model.TicketNumber"/></span>
            <span class="value">
              <button class="button" style="height:2em !important; border:none;">
                <i class="fa fa-copy" style="width:1em !important; color: lightgray" (click)="CopyToClipboard(Model.TicketNumber)"></i>
              </button>
            </span>
          </div>
          <div class="panel-block">
            <span class="label">Customer Details:</span>
            <span class="value">{{Model.FullName}}</span>
          </div>
          @if (Model.ValetTypeId != null) {
            <div class="panel-block">
              <a [routerLink]="'/valet/types/' + Model.ValetTypeId" style="text-decoration: underline; cursor: pointer;">
                <span class="label">Valet Type:</span>
                <span class="value">
                  <i [ngClass]="'Icon fa fa-' + Model.ValetTypeIconName" [ngStyle]="{color: '#' + Model.ValetTypeIconColor}"></i>
                </span>
                <span class="value"> - {{Model.ValetTypeName}}</span>
              </a>
            </div>
          }
          <div class="panel-block">
            <span class="label">Contact Number:</span>
            <span class="value">{{Model.PhoneNumber}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Vehicle Details:</span>
            <span class="value">{{Model.VehicleDescription}}</span>
          </div>
          @if (Model.ParkedAt != null) {
            <div class="panel-block">
              <span class="label">Parked at:</span>
              <span class="value">{{Model.ParkedAt}}</span>
            </div>
          }
          @if (Model.KeysLocation != null) {
            <div class="panel-block">
              <span class="label">Keys Location:</span>
              <span class="value disabled">{{Model.KeysLocation}}</span>
            </div>
          }
          @if (Model.KeyTagId != null) {
            <div class="panel-block">
              <span class="label">Key Tag:</span>
              <span class="value">{{Model.KeyTagId}}</span>
            </div>
          }
          @if (Model.ValetTypeId != null) {
            <div class="panel-block">
              <span class="label">Billing:</span>
              @if (!Model.HasFault) {
                <span class="value">{{Model.BillingKeyDescription}}</span>
              }
              @if (Model.HasFault) {
                <span class="value" style="color:red;">UNKNOWN</span>
              }
            </div>
          }
          @if (Model.RateSetId != null) {
            <div class="panel-block">
              <span class="label">Rate Set</span>
              <span class="value">
                {{Model.ParkingRateSetName}}
              </span>
            </div>
          }
          @if (Model.TotalPaymentRequired > 0) {
            <div class="panel-block">
              <span class="label">Payment Details</span>
              <span class="value">
                {{orgService.GetCurrencySymbol()}}{{Model.TotalPaid}} of {{orgService.GetCurrencySymbol()}}{{Model.TotalPaymentRequired}} paid ({{orgService.GetCurrencySymbol()}}{{Model.TotalOutstanding}} outstanding)
                <a class="fas fa-plus is-primary ml-3" (click)="MakeManualPayment()" tippy="Record a payment against this session"></a>
              </span>
            </div>
          }
          <div class="panel-block">
            <span class="label">Status:</span>
            <span class="value">
              <p style="text-align:end; margin-right:2em; width:6em; font-weight:600;" [ngStyle]="{'color': '#' + Model.State.ForegroundColor}" class="Text">{{Model.State.DisplayName}}<i [ngClass]="'Icon fa fa-' + Model.State.IconName" style="font-size: x-large; margin-top: 0px !important; position:absolute;"></i><p>
            </span>
            @for (issue of Model.Issues; track issue) {
              <span class="value" style="margin-left:10px;">
                <i [tippy]="issue.IssueDescription" [ngClass]="'Icon fa fa-' + issue.IssueIcon + ' Flash ' + issue.Severity + ' tippy-color-' + issue.IssueIconColor" style="width:1.5em !important; font-size:x-large" [ngStyle]="{'color' : '#' +  issue.IssueIconColor}"></i>
              </span>
            }
          </div>
          @if (Model.Status == 'Closed') {
            <div class="panel-block">
              <span class="label">Closed At:</span>
              <span class="value">{{Model.ClosedAtLocalFriendlyString}}</span>
            </div>
          }
          <div class="panel-block">
            <span class="label">Public Code:</span>
            <span class="value"><a [href]="Model.PublicPortalLink">{{Model.SessionShortCode}}</a></span>
          </div>
        </article>
      </div>
      <div class="column is-6 image-container">
        <img src="../../../../../assets/images/Valet-session.png" alt="FrogOne Valet Sessions" />
      </div>
    </div>
    <div class="columns">
      <div class="column is-12" >
        <article class="panel file uploadpanel" [ngClass]="{'dragging': isDragging}" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
          <button class="button is-primary upload"><i class="fa fa-upload" style="margin-right:10px;"></i> Upload</button>
          @for (image of Model.VehicleImages; track image; let i = $index) {
            <app-media-thumbnail [ModelId]="image.Id" [MediaId]="image.MediaFileId" [tippy]="'Taken ' + image.DateTakenLocalFriendlyString" [ShowDelete]="true" (Deleted)="RemoveImage(image)"></app-media-thumbnail>
          }
          <input type="file" class="file-input" [accept]="RequiredFileType" (change)="onFileSelected($event)" #fileUpload>
          <div [ngClass]="isDragging ? ' text dragging' : 'text hidden'">Drop file here to upload</div>
        </article>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <app-datalistview #DataList [Columns]="Columns" [ShowMap]="false" ApiUrl='valet/sessions/{{Model.Id}}/parkingsessions/searches'
        [AllowEdit]="false" [ShowPaging]="false" [EditUrlPerItem]="false" [HideSearch]="true" [HighlightOnSelect]="false"></app-datalistview>
      </div>
    </div>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Addons
          <span><button class="button is-primary" (click)="AddAddon()" style="
            height: 100%;
            font-size: 0.8em;
            padding: 0.2em;
            width: 9em;
            margin-left: 2em;"><i class="fa-solid fa-plus" style="margin-right:10px;"></i>Add</button></span>
            </p>
            <app-datalistview #AddonsDataList [Columns]="AddonColumns" [ShowColumnHeaders]="false" [ShowMap]="false" ApiUrl='valet/sessions/{{Model.Id}}/addons/searches'
              [AllowEdit]="false" [ShowPaging]="false" [EditUrlPerItem]="false" [HideSearch]="true" [AllowDropdownActions]="true" [UseActionsOnEachItem]="true" (HandleDropdownAction)="performAddonAction($event)" [HighlightOnSelect]="false"
            ></app-datalistview>
          </article>
        </div>
        <div class="column is-6">
          <article class="panel">
            <p class="panel-heading">
              Payments
            </p>
            <app-datalistview #PaymentsDataList [Columns]="PaymentColumns" [ShowMap]="false" ApiUrl='valet/sessions/{{Model.Id}}/payments/searches'
              [AllowEdit]="false" [ShowPaging]="false" [EditUrlPerItem]="false" [HideSearch]="true" [ShowColumnHeaders]="false" [HighlightOnSelect]="false"
              [AllowCustomAction]="true" CustomActionText="Record Refund" CustomActionIcon="rotate-left" (CustomActionEvent)="RecordRefund($event)"
              CustomActionConditionalField="TransactionReference" CustomActionConditionalValue="REFUND" CustomActionConditionalComparator="NOT contains"
            ></app-datalistview>
          </article>
        </div>
      </div>
    </div>
  }
